module.exports = __webpack_public_path__ + "img/cocteleria_5_2.b46220ed.png";